//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

//
// Component
//

export function initialiseCookieBanner(cookieBanner: HTMLElement)
{
	const button = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLButtonElement>(cookieBanner, ".component-button");

	button.addEventListener("click", 
		() =>
		{
			cookieBanner.remove();

			document.cookie = "eucookie=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
		});

	cookieBanner.classList.add("initialised");
}

export function initialiseCookieBanners()
{
	const cookieBanners = document.querySelectorAll<HTMLElement>(".component-cookie-banner:not(.initialised)");

	console.log("[CookieBanner] Initialising " + cookieBanners.length + " instances...");

	for (const cookieBanner of cookieBanners)
	{
		try
		{
			initialiseCookieBanner(cookieBanner);
		}
		catch (error)
		{
			console.error("[CookieBanner] Error initialising:", cookieBanner, error);
		}
	}
}